import { render, staticRenderFns } from "./Translation.vue?vue&type=template&id=14bd515f&scoped=true&"
import script from "./Translation.vue?vue&type=script&lang=js&"
export * from "./Translation.vue?vue&type=script&lang=js&"
import style0 from "./Translation.vue?vue&type=style&index=0&lang=less&"
import style1 from "./Translation.vue?vue&type=style&index=1&id=14bd515f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14bd515f",
  null
  
)

export default component.exports